import { BrandColors } from '../theme';

export const tagTokens = {
    root: {
        fontSize: '0.75rem',
        padding: '0.25rem 0.625rem',
        gap: '0.25rem',
        borderRadius: '4px',
        roundedBorderRadius: '2rem',
    },
    primary: {
        background: BrandColors.primary[100],
        color: BrandColors.primary[700],
    },
    secondary: {
        background: BrandColors.surface[100],
        color: BrandColors.surface[600],
    },
    success: {
        background: BrandColors.green[100],
        color: BrandColors.green[800],
    },
    info: {
        background: BrandColors.primary[100],
        color: BrandColors.primary[900],
    },
    warn: {
        background: BrandColors.yellow[100],
        color: BrandColors.yellow[700],
    },
    danger: {
        background: BrandColors.red[100],
        color: BrandColors.red[900],
    },
};
